import mobileP from "../../images/mobileP.png";
import front from "../../images/front.png";
import Graf from "../../images/Graf.png";

const data = [
  {
    id: 1,
    icon: mobileP,
    title: "برمجة التطبقيات",
    desc: "تصميم جذاب , يدعم جميع الاجهزة الاندرويد و الايفون بكل الاصدارات ، حق تملك كامل ل السورس كود, دعم ٢٤ ساعة",
  },
  {
    id: 2,
    icon: front,
    title: "تصميم واجهة المستخدم",
    desc: "التصميم المرئي للواجهة الرقمية للبرامج أو التطبيقات أو مواقع الويب و تشمل ضبط الخصائص المرئية والتفاعلية للمنتجات الرقمية",
  },
  {
    id: 3,
    icon: Graf,
    title: "التصميم الجرافك",
    desc: "غلافات صفحات الفيسبوك, قنوات اليوتيوب, تصميم اعلانات لمنتجك, دعم تصاميم ثلاثية الابعاد, متاح جميع الاحجام",
  },
  {
    id: 4,
    icon: mobileP,
    title: "برمجة التطبقيات",
    desc: "تصميم جذاب , يدعم جميع الاجهزة الاندرويد و الايفون بكل الاصدارات ، حق تملك كامل ل السورس كود, دعم ٢٤ ساعة",
  },
  {
    id: 5,
    icon: front,
    title: "تصميم واجهة المستخدم",
    desc: "التصميم المرئي للواجهة الرقمية للبرامج أو التطبيقات أو مواقع الويب و تشمل ضبط الخصائص المرئية والتفاعلية للمنتجات الرقمية",
  },
  {
    id: 6,
    icon: Graf,
    title: "التصميم الجرافك",
    desc: "غلافات صفحات الفيسبوك, قنوات اليوتيوب, تصميم اعلانات لمنتجك, دعم تصاميم ثلاثية الابعاد, متاح جميع الاحجام",
  },
];

export default data;
